import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/b292ac5952a4cdcba8e63b1df68fa6bb.jpg"
          alt="Yeni Başlangıçlar ve Umut"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Dark Overlay - 40% darkness */}
      <div className="absolute inset-0 bg-black/40 z-[1]"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight animate-fade-in drop-shadow-lg">
          {t('hero.title')}
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-3xl mx-auto leading-relaxed animate-fade-in-delay drop-shadow-md">
          {t('hero.subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center animate-fade-in-delay-2">
          <button 
            onClick={() => scrollToSection('integration')}
            className="px-8 py-4 bg-[#C9A961] text-[#1A2332] rounded-full text-lg font-semibold hover:bg-[#B89851] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta.primary')}
          </button>
          <button 
            onClick={() => scrollToSection('about')}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full text-lg font-semibold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta.secondary')}
          </button>
        </div>
      </div>
    </section>
  );
}
